<template>
  <div class="w-full flex flex-col justify-center items-center pb-2">
    <div class="tour-areas flex flex-wrap justify-center items-center gap-4">
      <div class="join">
        <button
          v-for="area in CONFIG_AREAS"
          :key="area"
          @click="currentArea = area"
          class="btn btn-tooltip join-item"
          :class="
            resolvedArea == area ? 'btn-active btn-primary' : 'btn-neutral'
          "
          :data-tip="AREA_TOOLTIPS[area]"
        >
          {{ area }}
        </button>
      </div>

      <div class="tour-areas join">
        <button
          v-for="area in USER_AREAS"
          :key="area"
          @click="currentArea = area"
          class="btn btn-tooltip join-item"
          :class="
            resolvedArea == area ? 'btn-active btn-primary' : 'btn-neutral'
          "
          :data-tip="AREA_TOOLTIPS[area]"
        >
          {{ area }}
        </button>
      </div>
    </div>

    <KeepAlive>
      <component :is="components[resolvedArea]"></component>
    </KeepAlive>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import {
  useHelpStore,
  CONFIG_AREAS,
  USER_AREAS,
  AREA_TOOLTIPS,
  AreaType,
} from "@/stores/help";
import KeysArea from "@/components/main/KeysArea.vue";
import LedsArea from "@/components/main/LedsArea.vue";
import MouseArea from "@/components/main/MouseArea.vue";
import GeneralArea from "@/components/main/GeneralArea.vue";
import KeycapsArea from "@/components/main/KeycapsArea.vue";
import DetectArea from "@/components/main/DetectArea.vue";

const help = useHelpStore();

const components: Record<AreaType, unknown> = {
  keys: KeysArea,
  leds: LedsArea,
  mouse: MouseArea,
  general: GeneralArea,
  keycaps: KeycapsArea,
  detect: DetectArea,
};

const currentArea = ref<AreaType>("keys");
const resolvedArea = computed(() => help.selectedArea ?? currentArea.value);

watch(currentArea, (newArea) => {
  help.currentGuideArea = newArea;
});
</script>
